import styled from "styled-components";
import { colors } from "../../../../../../../../consts";
import {
  Paragraph2,
  SmallButtonStyled,
  WrapperContainer
} from "../../../../../../../../components";

export const SliderWrapper = styled(WrapperContainer)`
  .slick-slider {
    .slick-arrow {
      display: none !important;
    }

    .slick-dots {
      bottom: unset;
      li {
        margin: 0;
        width: 18px;

        button:before {
          font-size: 8px;
        }
      }
    }
  }
`;

export const ContentWrapper = styled(WrapperContainer)`
  height: 218px;
  overflow-y: auto;
`;

export const ImageWrapper = styled(WrapperContainer)`
  height: 60%;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const VideoWrapper = styled(WrapperContainer)`
  height: 60%;
  max-width: 50%;

  video {
    height: 100%;
  }
`;

export const TextWrapper = styled(WrapperContainer)`
  ${Paragraph2} {
    text-align: center;
  }
`;

export const ButtonWrapper = styled(WrapperContainer)`
  ${SmallButtonStyled} {
    height: 40px;
    padding: 0 24px;
  }
`;

export const Dot = styled(WrapperContainer)`
  width: 7px;
  height: 7px;
  border-radius: 100%;
  background: ${colors.RAISIN_100};
`;
